import React from 'react';
import PropTypes from 'prop-types';
import renderNewlinesAsJsxBreaks from '../helpers/renderNewlinesAsJsxBreaks';

const Title = ({ children, className, tag: Tag }) => (
  <Tag className={className}>
    {Array.isArray(children)
      ? children.map(child => renderNewlinesAsJsxBreaks(child))
      : renderNewlinesAsJsxBreaks(children)}
  </Tag>
);

Title.propTypes = {
  className: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array,
  ]).isRequired,
  tag: PropTypes.oneOf(['h1', 'h2', 'h3', 'h4', 'p']).isRequired,
};

Title.defaultProps = {
  className: undefined,
};

export default Title;
